import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import Students from './components/students/Students';

const StudentManagement = () => {
  return renderComponent(<Students />);
};

export default StudentManagement;
